'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addValidators;

var _extendsSchema = require('../schema/extendsSchema');

var _extendsSchema2 = _interopRequireDefault(_extendsSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var isInvisible = function isInvisible(v) {
  return v === '' || v === undefined || v === null;
};
function makeRequiredValidator(_ref) {
  var name = _ref.name;

  return function (value) {
    if (isInvisible(value)) return name + ' \u70BA\u5FC5\u586B';
    return undefined;
  };
}

function composeValidator(validators) {
  return function (value) {
    var errors = validators.reduce(function (arr, validator) {
      var error = validator(value);
      if (error) arr.push(error);
      return arr;
    }, []);

    if (errors.length === 0) return undefined;
    return errors.join('\n');
  };
}
function makeValidator(_ref2) {
  var validator = _ref2.validator,
      required = _ref2.required,
      rest = _objectWithoutProperties(_ref2, ['validator', 'required']);

  var validators = validator ? [].concat(validator) : [];

  if (required) validators.push(makeRequiredValidator(rest));

  if (validators.length === 0) return undefined;

  return {
    validator: function validator(value) {
      // let empty value pass for not required field
      if (!required && isInvisible(value)) return undefined;
      return composeValidator(validators)(value);
    }
  };
}

function addValidators(schema) {
  return (0, _extendsSchema2.default)(schema, makeValidator);
}


//////////////////
// WEBPACK FOOTER
// ./~/coact/utils/validation/addValidators.js
// module id = 1041
// module chunks = 0